const serviceTerms = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: "This section provides a high-level summary of the terms governing your use of our AI services. By accessing the platform, you agree to comply with all provisions outlined in this document."
    },
    { 
        id: "acceptable-use", 
        title: "2. Acceptable Use", 
        content: "Our platform must be used responsibly and ethically. Activities such as unauthorized access, distribution of harmful software, or engaging in unlawful behavior are strictly prohibited."
    },
    { 
        id: "subscription", 
        title: "3. Subscription Terms", 
        content: "Access to our services is provided through subscription plans, billed on a recurring basis. Failure to make timely payments may lead to suspension or termination of your account."
    },
    { 
        id: "user-obligations", 
        title: "4. User Obligations", 
        content: "Users must safeguard their account credentials and are responsible for any activities conducted under their account. Any suspicious or unauthorized activity should be reported immediately."
    },
    { 
        id: "limitation-liability", 
        title: "5. Limitation of Liability", 
        content: "[Startup Name] shall not be held liable for indirect or incidental damages resulting from the use or inability to use the platform, as permitted by applicable law."
    },
    { 
        id: "termination", 
        title: "6. Termination", 
        content: "We reserve the right to terminate your access to the platform for breaches of these Terms or at our discretion, with due notice where applicable."
    },
    { 
        id: "intellectual-property", 
        title: "7. Intellectual Property", 
        content: "All intellectual property rights related to the platform's content and technology belong to [Startup Name]. Users are granted a limited license for personal or business use in compliance with these Terms."
    },
    { 
        id: "governing-law", 
        title: "8. Governing Law", 
        content: "These Terms are governed by the laws of [Jurisdiction]. Any disputes shall be resolved in the courts of [City/Region]."
    },
    { 
        id: "contact-info", 
        title: "9. Contact Information", 
        content: "For inquiries about these Terms or our services, please contact us at support@[startupname].com or call +[Phone Number]."
    }
];

export default serviceTerms;